<template>
    <div>
        <div>
            <div class="wrap">
                <div class="main-wrap">
                    <div class="main-wrap__grid">
                        <div class="nav-tree">
                            <el-select v-model="activePressetId" :placeholder="$t('settings_permissions_selectPresset')" size="mini">
                                <el-option disabled label="Fixed Permissions" value="1"></el-option>
                                
                                <el-option
                                        v-for="item in pressetsList"
                                        v-show="item.isDefault"
                                        :key="item.id"
                                        :label="$t(item.permissionPressetName)"
                                        :value="item.id"
                                        @click.native="onSelectionChanged(item)">
                                </el-option>

                                <el-option disabled label="Created Permissions" value="2"></el-option>

                                <el-option
                                        v-for="item in pressetsList"
                                        v-show="!item.isDefault"
                                        :key="item.id + 1000"
                                        :label="$t(item.permissionPressetName)"
                                        :value="item.id"
                                        @click.native="onSelectionChanged(item)">
                                </el-option>
                            </el-select>
                            <el-button
                                    style="margin-left:20px;"
                                    size="mini"
                                    type="primary"
                                    plain
                                    @click="createPressetOpenModal"
                            >{{$t('settings_permissions_create')}}</el-button>
                            <el-button
                                    :disabled="!activePressetId || activePressetName === 'user' || activePressetName === 'manager' || isDefault"
                                    size="mini"
                                    type="primary"
                                    plain
                                    @click="savePresset(activePressetId)"
                            >{{$t('settings_permissions_save')}}</el-button>
                            <el-button
                                    :disabled="!activePressetId || activePressetName === 'user' || activePressetName === 'manager' || isDefault"
                                    size="mini"
                                    type="primary"
                                    plain
                                    @click="deletePressetOpenModal(activePressetId)"
                            >{{$t('settings_permissions_delete')}}</el-button>
                        </div>
                    </div>
                    <div v-if="activePressetId" class="main-wrap__table">
                        <el-checkbox-group v-model="selectedPermissionsIds">
                            <div v-for="(permissions, index) in permissionsList" :key="index" class="permissions">
                                <div class="permissions__title">{{$t(permissions.permissionFilterName)}}:</div>
                                <el-checkbox v-for="(permission, index) in permissions.permissionList" :label="permission.id" :key="index">{{$t(permission.permissionName)}}</el-checkbox>
                            </div>
                        </el-checkbox-group>
                    </div>
                    <div class="main-wrap__actions">

                    </div>
                </div>
            </div>
        </div>
        <sweet-modal v-on:close="closeModal"  :title="$t('settings_permissions_createPresset')" blocking class="nested-confirm" ref="createPressetModal">
            <el-form label-position="top" :model="form" size="mini" ref="form" status-icon :rules="rules"  class="createPressetForm">
                <el-form-item prop="name">
                    <el-input v-model="form.name" size="mini" :placeholder="$t('settings_permissions_name')"></el-input>
                </el-form-item>
                <el-form-item prop="permissions" :label="$t('settings_permissions')">
                <el-checkbox-group v-model="form.permissions">
                    <div v-for="(permissions, index) in permissionsList" :key="index" class="permissions">
                        <div class="permissions__title">
                          {{$t(permissions.permissionFilterName)}}
                          <div @click="selectAll(permissions.permissionList)" class="permissions__all">{{$t('general_selectAll')}}</div>
                        </div>
                        <el-checkbox v-for="(permission, index) in permissions.permissionList" :label="permission.id" :key="index">{{$t(permission.permissionName)}}</el-checkbox>
                    </div>
                </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button  @click="create('form')" class="modal__btn" type="primary" plain size="mini">{{$t('settings_permissions_create')}}</el-button>
                </el-form-item>
            </el-form>
        </sweet-modal>
    </div>
</template>

<script>
  let moment = require('moment')
  import axios from 'axios'
  import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
  // import {AgGridVue} from "ag-grid-vue"
  import { VueEditor } from 'vue2-editor'
  export default {
    name: 'ProjectPermissions',
    components: {
      SweetModal,

    },
    beforeCreate() {

    },
    beforeMount() {

    },
    mounted(){
    },
    data() {
      return {
        isDefault: true,
        companyId: null,
        permissionsList: [],
        activePressetId: null,
        activePressetName: '',
        pressetsList: [],
        selectedPermissionsIds: [],
        form: {
          name: null,
          permissions: []
        },
        formEdit: {
          name: null,
          permissions: []
        },
        rules:{
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
        rulesEdit:{
          name: [
            { required: true, message: this.$i18n.t('modal_settings_fieldIsRequired'), trigger: 'blur' }
          ],
        },
      }
    },
    methods: {
      selectAll(list) {
        for (let i = 0; i < list.length; i++) {
          if (this.form.permissions.indexOf(list[i].id) == -1) {
            this.form.permissions.push(list[i].id)
          }
        }
      },
      async loadProjectPermissionsList(){
        try {
          this.permissionsList = await this.getPermissionsRulesList();

          this.pressetsList = await this.getPermisssionsPressetsList()
        } catch (err) {
          console.log(err)
        }
      },
      getPermissionsRulesList(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionRules/list?permissionGroup=2`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.list);
              loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        })
      },
      getPermisssionsPressetsList(){
        return new Promise ((resolve, reject) => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .get(`/api/v1/permissionPressets/list?permissionGroup=2&companyId=${this.$route.query.companyId}`)
            .then(response => {
              console.log('---', response.data);
              resolve(response.data.list)
              loader.hide()
            })
            .catch(error => {
              loader.hide();
              console.log('An error occurred:', error);
            });
        })
      },
      onSelectionChanged(item){
        this.selectedPermissionsIds = item.permissionPressetIdArr
        this.activePressetName = item.permissionPressetName
        this.companyId = item.companyId
        this.isDefault = item.isDefault
      },
      async createPressetOpenModal(){
        try {
          this.permissionsList = await this.getPermissionsRulesList();

          this.$refs.createPressetModal.open()

        } catch (err) {
          console.log(err)
        }


      },
      create(form) {
        this.$refs[form].validate((valid) => {
            if (valid) {
              let loader = this.$loading.show();
              const data = {
                name: this.form.name,
                companyId: this.$route.query.companyId,
                permissions: this.form.permissions
              };
              axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
              axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
              axios
                .post(`/api/v1/permissionPressets/create?permissionGroup=2`, data)
                .then(async response => {
                  try {
                    console.log('---', response.data);

                    loader.hide();

                    this.notification(this.$t('general_success'), this.$t('settings_permissions_pressetSuccessfullyCreated'), "success");

                    this.$refs.createPressetModal.close();

                    this.permissionsList = await this.getPermissionsRulesList();

                    this.pressetsList = await this.getPermisssionsPressetsList();

                    const createdPresset = this.pressetsList.find(val => val.id === response.data.permissionsPressetId);

                    this.activePressetId = response.data.permissionsPressetId;

                    this.selectedPermissionsIds = createdPresset.permissionPressetIdArr;

                  } catch (err) {
                    console.log(err)
                  }
                })
                .catch(error => {
                  loader.hide();
                  console.log('An error occurred:', error);
                });
            }
        })
      },
      savePresset(pressetId){

        const data = {
            name: this.pressetsList.find(val => val.id === pressetId).permissionPressetName,
            companyId: this.$route.query.companyId,
            permissions: this.selectedPermissionsIds
        };

        if (data.name === 'userProject' || data.name === 'managerProject') {
          this.notification(this.$t('general_warning'), this.$t('settings_permissions_cantChangeDefaultPresset'), "info");
          return
        }

        let loader = this.$loading.show();
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
        axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
        axios
          .post(`/api/v1/permissionPressets/update?pressetId=${pressetId}`, data)
          .then(async response => {

            loader.hide();

            this.notification(this.$t('general_success'), this.$t('settings_permissions_updatePresset'), "success");

            this.pressetsList = await this.getPermisssionsPressetsList();

          }).catch(err => {
            loader.hide();
          console.log(err)
        })
      },
      deletePressetOpenModal(pressetId){

        const deletedPressetName = this.pressetsList.find(val => val.id === pressetId).permissionPressetName


        if (deletedPressetName === 'userProject' || deletedPressetName === 'managerProject') {
          this.notification(this.$t('general_warning'), this.$t('settings_permissions_cantDeleteDefaultPresset'), "info");
          return
        }

        this.$confirm(this.$t('settings_permissions_thisWillPermanentlyDeleteThePressetContinue'), this.$t('general_warning'), {
          confirmButtonText: this.$t('general_ok'),
          cancelButtonText: this.$t('general_cancel'),
          type: 'info'
        }).then(() => {
          let loader = this.$loading.show();
          axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
          axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
          axios
            .post(`/api/v1/permissionPressets/delete?pressetId=${pressetId}&companyId=${this.companyId}`)
            .then(async response => {
              try {
                console.log('---/permissionPressets/delete', response.data);

                this.notification(this.$t('general_success'), this.$t('settings_permissions_deletePresset'), "success");

                this.pressetsList = await this.getPermisssionsPressetsList();

                this.activePressetId = null;

                loader.hide()

              } catch (err) {
                console.log(err)
              }
            })
            .catch(error => {
              console.log('An error occurred:', error);
              loader.hide()
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('general_deleteCanceled')
          });
        });
      },
      notification(title, message, type) {
        this.$notify({
          title: title,
          message: message,
          type: type
        });
      },
      closeModal(){
        this.$refs['form'].resetFields();
      },
      closeModalEdit(){
        this.$refs['formEdit'].resetFields();
      }
    }
  }
</script>

<style lang="less" scoped>
    .permissions {
        margin-bottom: 20px;
        &__title {
            font-size: 20px;
            margin-bottom: 5px;
            color: #B11A21;
        }
        &__all {
          display: inline-block;
          font-size: 18px;
          padding: 2px;
          color: #ccc;
          border: 1px solid #ccc;
          border-radius: 5px;
          cursor: pointer;
        }
        &__all:hover {
          color: #409EFF;
          border: 1px solid #409EFF;
        }
    }
</style>

<style lang="scss" scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
        opacity: 0;
    }
    .flex{
        /*display:flex;*/
    }
    .content {
        /*display: flex;*/
    }
    .wrap {
        width: 100%;
        padding: 0 10px 10px 10px;
    }
    .main-wrap{
        height:95%;
    }
    .main-wrap__table{
        width:100%;
        padding: 10px;
        h3{
            margin-top: 0;
            margin-bottom: 35px;
        }
    }
    .main-wrap__grid{
        width:600px;
        padding: 10px;
    }
    /*.nav-tree{*/
        /*display:flex;*/
        /*justify-content: space-between;*/
    /*}*/
    .group-name{
        margin-left:10px;
    }
    .update-btn{
        margin-top:20px;
    }
    /deep/.first-column{
        .cell{
            display:flex;
            justify-content:space-between;
        }
    }
    /deep/.el-checkbox {
      width: 240px;
      margin-right: 15px;
    }
</style>


